<template>
    <div>
        <v-dialog
            v-model="openChatMessage"
            z-index="999"
            max-width="1300px"
            style="z-index: 999;"
        >
            <div style="background-color: #fff;">
                <Chat :closeChatModal="closeChat" />
            </div>
        </v-dialog>
        <Header @changeComponent="changeComponent" v-bind:avatarPreviewUrl="this.avatarPreviewUrl" class="d-none d-md-flex"/>
        <HeaderPortable @changeComponent="changeComponent" @openAlertPopupDownload="openAlertPopupDownload" v-bind:id="company_id" class="d-flex d-md-none"/>
        <v-row>
            <v-col cols="0" md="2" lg="2" class="d-none d-md-flex" style="z-index: 10">
                <Menu @changeComponent="changeComponent" @openAlertPopupDownload="openAlertPopupDownload" v-bind:current="$store.state.page" ref="MenuDashboard"/>
            </v-col>

            <v-col class="container px-10 text-left" cols="12" md="9" lg="10">
                <AlertPopup v-if="this.enablePopup" @closePopup="closeDialog()" :company_id="company_id" :type="type" :application="application" />
                <div
                :is="component"
                v-bind:avatarPreviewUrl="this.avatarPreviewUrl"
                v-bind:company_id="this.company_id"/>
            </v-col>
        </v-row>
        <div class="open-chat-icon" @click="openChatMessage = true">
            <img src="../assets/img/circle.png" height="55" />
            <span class="position-absolute badge rounded-circle bg-info text-white" style="top: 0px; left: 2px">
                {{ totalMessages }}
            </span>
        </div>
        <Footer/>
    </div>
</template>


<script>
import AlertPopup from "@/components/AlertPopup.vue";
import Profile from "@/store/services/profile-service";
import ChatApi from "@/store/services/chat/chat.service.js";

import Header from '@/components/Dashboard/Investor/HeaderDashboard.vue';
import HeaderPortable from '@/components/Dashboard/Investor/HeaderDashboardPortable.vue';
import Footer from '@/components/FooterCms.vue';
import Menu from '@/components/Dashboard/Investor/DashboardMenu.vue';

import MainContact from '@/components/Dashboard/Investor/MainContact.vue'
import LegalRepresentative from '@/components/Dashboard/Investor/LegalRepresentative.vue'
import Accreditation from '@/components/Dashboard/Investor/Accreditation.vue'
import InvestmentStrategy from '@/components/Dashboard/Investor/InvestmentStrategy.vue'

import Product from '@/components/Dashboard/TypeOfBusiness.vue'
import FinanceHistory from '@/components/Dashboard/FinanceHistory.vue'
import FundingNeeds from '@/components/Dashboard/FundingNeeds.vue'
import BillingAddress from '@/components/Dashboard/Investor/BillingAddress.vue'
import Invoices from '@/components/Dashboard/Investor/Invoices.vue'
import ChangePwd from '@/components/Dashboard/Modifypwd.vue'
import AccountStatus from '@/components/Dashboard/Investor/AccountStatus.vue'
import FindNewDeals from '@/components/Dashboard/Investor/FindNewDeals.vue';
import FollowUp from '../components/Dashboard/Investor/FollowUp.vue';
import InvestmentsDeal from '../components/Dashboard/Investor/dealDetails/InvestmentsDeal.vue';
import Chat from '../views/chat/Chat.vue';

export default {
    components: {
        Header,
        HeaderPortable,
        Footer,
        Menu,
        AlertPopup,

        MainContact,
        LegalRepresentative,
        Accreditation,
        InvestmentStrategy,

        FindNewDeals,
        FollowUp,
        InvestmentsDeal,

        Product,
        FinanceHistory,
        FundingNeeds,
        BillingAddress,
        Invoices,
        ChangePwd,
        Chat
    },
    data() {
        return {
            company_id: null,
            component: AccountStatus,
            avatarPreviewUrl: null,
            // current: 'followUp',
            enablePopup: false,
            type: null,
            application: null,
            openChatMessage: false,
            totalMessages: 0,
        }
    },
    watch: {
        '$store.state.page': {
            handler(newValue, oldValue) {
                this.changeComponent(newValue)
            },
            immediate: true, // Optional: executes the watcher immediately with the current value.
            deep: false,     // Optional: set to true if watching nested objects for changes.
        },

        '$store.state.messageUpdates': {
            handler() {
                this.getTotalMessages();
            },
            immediate: true, // Optional: executes the watcher immediately with the current value.
            deep: false,     // Optional: set to true if watching nested objects for changes.
        }
    },

    methods: {
        closeChat () {
            this.openChatMessage = false;
        },
        changeComponent(comp) {
            // this.current = comp;
            // this.$store.commit("UPDATE_PAGE", comp);
            this.component = null;
            // if (id != null) { this.company_id = id; }
            if (comp == 'mainContact') { this.component = MainContact; }
            else if (comp == 'legalRepresentative') { this.component = LegalRepresentative; }
            else if (comp == 'accreditation') { this.component = Accreditation; }
            else if (comp == 'investment_strategy') { this.component = InvestmentStrategy; }

            else if (comp == 'findNewDeals') { this.component = FindNewDeals}
            else if (comp == 'followUp') { this.component = FollowUp}
            else if (comp == 'investments') { this.component = InvestmentsDeal}

            else if (comp == 'product') { this.component = Product; }
            else if (comp == 'financeHistory') { this.component = FinanceHistory; }
            else if (comp == 'fundingNeeds') { this.component = FundingNeeds; }
            else if (comp == 'billingAddress') { this.component = BillingAddress; }
            else if (comp == 'invoices') { this.component = Invoices; }
            else if (comp == 'changepwd') { this.component = ChangePwd; }
            else if (comp == 'AccountStatus') { this.component = AccountStatus; }
            else if (comp == 'chatInvestor') { this.component = Chat; }
        },
        updateGoogleAnalytics()
        {
            this.$gtag.event('Company_Dashboard', { method: 'Google' });
        },
        openAlertPopupDownload(val, application){
            this.type = val;
            this.application = application;
            this.enablePopup = true;
        },
        closeDialog() {
            this.enablePopup = false;
            this.current = this.$store.state.page; //'mainContact';
        },
        getTotalMessages() {
            ChatApi.getUnreadMessages().then((res) => {
                this.totalMessages = res.data.totalMessages;
            })
        }
    },

    created() {
        Promise.all([
            Profile.getAvatar()
            .then((res) => { this.avatarPreviewUrl = res.data; })
            .catch((error) => { 
                //console.log(error); 
            }),

            this.getTotalMessages()
        ]);
    },
}
</script>
<style>
    .chat-icon {
        position: absolute;
        z-index: 999;
        bottom: 450px;
        right: 90px;
    }
    .icon {
        position: fixed;
    }
</style>